import React, { forwardRef } from 'react';
import { ImageProps, Source } from './types';
import * as theme from './constants';

const Image = forwardRef<HTMLImageElement, ImageProps>(
  ({ sources, src, className, width = '100%', alt, style, objectFit, ...rest }, ref) => {
    const key = () => Math.random() * 1000;
    const isPictureTag = sources && sources.length > 0;
    const generateSrcSet = (img: Source['srcSet']) => `${img.regular} 1x, ${img.retina ? `${img.retina} 2x` : ''} `;
    const imgStyle = { objectFit, ...style };

    return isPictureTag ? (
      <picture>
        {sources.map((img) => (
          <source key={key()} srcSet={generateSrcSet(img.srcSet)} media={theme.breakpoints[img.media]} />
        ))}
        <img
          alt={alt}
          ref={ref}
          style={imgStyle}
          className={className}
          src={sources[0].srcSet.regular}
          width={width}
          {...rest}
        />
      </picture>
    ) : (
      <img alt={alt} ref={ref} style={imgStyle} className={className} src={src} width={width} {...rest} />
    );
  }
);

Image.displayName = 'Image';

export default Image;
